// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    language: 'FR',
    // resetLink:'https://aurep-production.firebaseapp.com',
    resetLink:'https://mini-simulabox-dev.firebaseapp.com',
    // backEndUrl: 'http://localhost:5000/simulabox-dev/us-central1',
    // backEndUrl: 'https://us-central1-aurep-production.cloudfunctions.net',
    backEndUrl: 'https://us-central1-mini-simulabox-dev.cloudfunctions.net',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
